import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsFiltering, selectPage, selectRowsPerPage } from 'store/Filters/selectors';
import { selectTotalItems, unSelectAll, unselectTotalItems, unselectedRowFromSelectAll } from 'store/Contextualization/AssetDetail/actions';
import { allVulnsAreSelected, selectCount, selectSelectAllVulns, selectSelected } from 'store/Contextualization/AssetDetail/selectors';
import { Wrapper, Text, Blue, Bold } from 'Screens/Contextualization/Manage/components/ManageTable/components/SelecAll/styled';

const SelectAll = () => {
  const dispatch = useDispatch();
  const allVisualVulnsSelected = useSelector(allVulnsAreSelected);
  const pageLimit = useSelector((state) => selectRowsPerPage('vulnsAssets', state));
  const page = useSelector((state) => selectPage('vulnsAssets', state));
  const selectAll = useSelector(selectSelectAllVulns);
  const vulnsSelected = useSelector((state) => selectSelected('vulns', state));
  const vulnCount = useSelector((state) => selectCount('vulns', state));
  const isFiltering = useSelector(state => selectIsFiltering('vulnsAssets', state));

  const handleSelectAll = () => {
    dispatch(selectTotalItems('vulns'));
  };
  const handleClear = () => {
    dispatch(unselectTotalItems('vulns'));
    dispatch(unSelectAll('vulns'));
    dispatch(unselectedRowFromSelectAll(false, 'vulns'));
  };

  const content = () => {
    if (selectAll) {
      return (
            <Text>
        All <Bold>{vulnCount}</Bold> Vulnerabilities on this {isFiltering ? 'search' : 'Asset'} are selected. <Blue onClick={ handleClear }>Clear Selection</Blue>
            </Text>
      );
    } else if (isFiltering) {
      return (
<Text>
        All <Bold>{vulnsSelected.length}</Bold> Vulnerabilities on this page are selected. <Blue onClick={ handleSelectAll }>Select all Vulnerabilities that match this search.</Blue>
</Text>
      );
    } else {
      return (
<Text>
        All <Bold>{vulnsSelected.length}</Bold> Vulnerabilities on this page are selected. <Blue onClick={ handleSelectAll }>Select all {vulnCount} Vulnerabilities in Asset</Blue>
</Text>
      );
    }
  };
  if (!allVisualVulnsSelected) return null;
  if ((vulnsSelected.length < pageLimit && page === 1 && !allVisualVulnsSelected) || vulnCount <= pageLimit) return null;
  return <Wrapper> {content()} </Wrapper>;
};

export default SelectAll;
